import request from "@/utils/requestToTrackingServer";
import requestMajestic from "@/utils/requestToMajesticServer";

function getUrlParameter(name, location) {
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  var results = regex.exec(location);
  return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export function saveEvent(context, name) {
  const video_id = context.rootState.brandChannel.tape.video_id;
  const session_id = window.__ovmSID;

  if (typeof session_id === "undefined") {
    console.error("tracking/saveEvent called without SessionID!");
    return false;
    // throw new Error("No SessionID error"); // pq não funciona?!??!
  }

  if (typeof video_id === "undefined") {
    console.warn("tracking/saveEvent called without VideoID!");
  }

  const event = {
    name,
    video_id,
    session_id,
    timestamp: new Date().toISOString()
  };

  const user_id = context.rootState.brandChannel.tape.ovmConfig.env.user_id;
  if (user_id !== "undefined") {
    event.client_viewer_id = user_id;
  }

  if (navigator && navigator.userAgent) {
    event.user_agent = navigator.userAgent;
  }

  const uuid = getUrlParameter("id",context.rootState.brandChannel.tape.path)

  if(video_id == '63fce5ad110381000297230d'){ //liberty gratificações
    return requestMajestic({
      url: "/events/save",
      method: "post",
      data: event,
      headers: {
        'uuid': uuid // Adiciona o UUID como valor do header 'X-Request-Id'
      }
    });
  }else {
    return request({
      url: "/events/save",
      method: "post",
      data: event,
      headers: {
        'uuid': uuid // Adiciona o UUID como valor do header 'X-Request-Id'
      }
    });
  }
}
